import PersonalInfoContent from './PersonalInfoContent';

export default PersonalInfoContent;
